import React from "react";

import { yupResolver } from "@hookform/resolvers/yup";
import { FormProvider, useForm } from "react-hook-form";
import * as yup from "yup";
import { PaziaButton, PaziaSwitch } from "components/atoms";
import { settingsApi } from "api";
import { useInvalidateSettings } from "api/hooks/useInvalidateSettings";
import { getApiErrorMessage, useToaster } from "utils";

export interface AutopayRefundsSettingsFormProps {
  enabled: boolean;
}

export const AutopayRefundsSettingsForm = ({ enabled }: AutopayRefundsSettingsFormProps) => {
  const { showError, showSuccess } = useToaster();
  const invalidateSettings = useInvalidateSettings();
  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: { enabled },
  });

  const onSubmit = async (values: AutopayRefundsSettingsValues) => {
    try {
      await settingsApi.saveAutopayRefunds(values);
      await invalidateSettings();
      methods.reset(values);
      showSuccess("Zapisano ustawienie zwrotów przez Autopay");
    } catch (error) {
      showError(getApiErrorMessage(error, "Błąd podczas zapisywania ustawienia zwrotów przez Autopay"));
    }
  };

  const {
    handleSubmit,
    formState: { isDirty },
  } = methods;

  return (
    <FormProvider {...methods}>
      <form className="flex flex-col gap-2" onSubmit={handleSubmit(onSubmit)}>
        <div className="flex flex-wrap items-center gap-4">
          <PaziaSwitch name="enabled" label="Zwroty przez Autopay" />
          <PaziaButton type="success" disabled={!isDirty} title="Zapisz" />
        </div>
        <p className="text-sm text-slate-500 dark:text-slate-400">
          Pozwala zlecać zwroty z widoku Finanse. Włącz po kontrolnym zwrocie 1 zł.
        </p>
      </form>
    </FormProvider>
  );
};

const schema = yup
  .object({
    enabled: yup.boolean().required(),
  })
  .required();

export type AutopayRefundsSettingsValues = yup.InferType<typeof schema>;
